
import { User } from "firebase/auth";
import { SignOutUser, db, userStateListener } from "../firebase";
import { createContext, useState, useEffect, ReactNode } from "react";
import { getDoc, doc, Timestamp } from "firebase/firestore";
// import { fetchUserData } from "../firebase_admin";

interface Props {
  children?: ReactNode
}

export interface UserProfile {
  groupId: string | null;
  birthday: Date | null;
  recoveryPlan: string | null;
  height: number | null;
  id: string;
  jobHeavyLifting: string | null;
  name: string;
  occupation: string | null;
  sex: string | null;
  recoveryPlanDate: Timestamp | null;
  userProgressID: string | null;
  weight: number | null;
  email: string|null;
  researcher: boolean | null;
  userSequences: {'VM1MOAABLE': number, 'VM4MOAABLE': number, 'VM6MOAABLE': number} | null;
  forms: Array<{ form_id: number; completed: boolean }> | null;
}

export const AuthContext = createContext({
  // "User" comes from firebase auth-public.d.ts
  currentUser: {} as User | null,
  profile: {} as any,
  setCurrentUser: (_user:User) => {},
  signOut: () => {},
  loading: true
});

export const getUserProfile = async (uid: string) => {
  const docT = await getDoc(doc(db, 'users', uid))
  // const email = await fetchUserData(uid)
  return { ...docT.data(), id: docT.id} as UserProfile
}

export const AuthProvider = ({ children }: Props) => {
  const [currentUser, setCurrentUser] = useState<User | null>(null)
  const [profile, setProfile] = useState<UserProfile | null>(null)
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const unsubscribe = userStateListener((user) => {
      if (user) {
        // get user profile from firestore
        getUserProfile(user.uid).then((profile: UserProfile) => {
          setProfile(profile)
        })
      }
      setCurrentUser(user)
      setLoading(false)
    });
    return unsubscribe
  }, [setCurrentUser]);

  // As soon as setting the current user to null, 
  // the user will be redirected to the home page. 
  const signOut = () => {
    SignOutUser()
    setCurrentUser(null)
  }

  const value = {
    currentUser,
    profile,
    setCurrentUser,
    signOut,
    loading
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}